<template>
  <div id="app">
    <layout></layout>
  </div>
</template>

<script>
import Layout from './layout'
export default {
  name: 'App',
  components: {Layout}
}
</script>
<style>
a{text-decoration:none}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /* position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  top: 0; */
  /*margin-top: 60px;*/
}

body {
  background-color: #e0f0e9;
  margin: 0px;
}
.w1280 {
  margin: 0 auto;
  width: 98%;
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue